import type { OddsFormat } from '@pickpro/contracts';
import { useSession } from './use-session';

export const DEFAULT_ODDS_FORMAT: OddsFormat = 'decimal';

export const useOddsFormat = (): OddsFormat =>
  useSession().user?.settings.oddsFormat ?? DEFAULT_ODDS_FORMAT;
